export enum DeviceMeteringMode {
	PreFader = 'PRE_FADER',
	PostFader = 'POST_FADER'
}
